import React from 'react'
import { Image } from 'antd'

export const ContentfulRenderAsset = ({ node, assets }) => {
  const currentAsset = assets.find((asset) => asset.sys.id === node.data.target.sys.id)
  if (!currentAsset) return null

  const { file, title } = currentAsset.fields || {}
  const { contentType, url } = file || {}

  if (contentType?.startsWith('image/')) {
    return <Image src={url} alt={title || 'Embedded Image'} />
  }

  if (contentType?.startsWith('video/')) {
    return (
      <video
        controls
        style={{
          maxWidth: '100%',
          maxHeight: '250px',
          objectFit: 'contain',
        }}
      >
        <source src={url} type={contentType} />
      </video>
    )
  }

  return null
}
